module.exports = __webpack_public_path__ + "static/media/kor_3.81f702ff.jpg";